
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-riwayat",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-riwayat/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-riwayat"])
      });
    }
  